import { api, getRequestBody, type Config } from './api';

export async function put<T>(url: string, data: any, config?: Config): Promise<T> {
  const body = getRequestBody(data);
  return api<T>(`${url}${config?.params ? `?${new URLSearchParams(config.params).toString()}` : ''}`, {
    ...(body && { body }),
    method: 'put',
    headers: config?.headers ? { ...config.headers } : {}
  });
}
